import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import moment from 'moment'
import { LKDate } from 'loankeeper-common/helpers/Date'
import transformProp from 'loankeeper-common/containers/transformProp'
import withLoadingState from 'loankeeper-common/containers/withLoadingState'
import { translate as translateHelper } from 'loankeeper-common/helpers'
//@ts-ignore
import withLivedata from 'shared/containers/withLivedata'
import { addEditClientDelegate } from '../../../../../store/client'
import isUndefined from 'lodash/isUndefined'
import get from 'lodash/get'
//@ts-ignore
import withLookups from 'shared/containers/withLookups'
//@ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'
import { Input } from 'semantic-ui-react'
//@ts-ignore
import DropdownField from 'shared/FormFields/DropdownField'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
import { actions as DetailsContainerActions } from '../../../../DetailsContainer'
import { addDelegateModalName, addDelegateFormName } from '../../../constants'
import { translateDelegates, translateLKMessage } from '../../../helpers'
import { openFileDetails } from '../../../../FileDetails'
import {
  ClientDelegateAddModalFormValues,
  ClientDelegateAddModalParams,
  ClientDelegateAddModalProps,
  ClientDelegateAddModalState,
} from 'src/features/ClientDetails/types'

const valueSelector = formValueSelector(addDelegateFormName)

const translateWebMessages = (name: string): string => translateHelper(`frm_web_messages-${name}`)

//@ts-ignore
@withLoadingState
@LKModalContainer(addDelegateModalName)
@withLookups({
  type: 'sys',
  query: 'Client_RLType as options',
})
//@ts-ignore
@transformProp('options', (options) =>
  options.map(({ ID, Title }) => ({
    value: ID,
    text: Title,
  })),
)
@withLivedata('OpenDayStatus.Open_Day as OpenDay')
//@ts-ignore
@connect(
  (
    state,
    {
      params: { isEdit, client },
      options = [],
      OpenDay,
    }: {
      params: ClientDelegateAddModalParams
      options: Array<{ value: number; text: string }>
      OpenDay: string
    },
  ) => {
    let initialValues

    if (isEdit) {
      const {
        Active,
        ConnectionType,
        Comment,
        StartDate,
        EndDate,
        LFLID,
        CashOper,
        Share,
        clientId,
        HashSum_RLClientID_,
        ID,
        Hash,
        RLTypeID,
      } = client

      initialValues = {
        active: Active,
        comment: Comment,
        ID,
        hash: Hash,
        connectionType: ConnectionType,
        startDate: moment(StartDate).format('DD.MM.YYYY'),
        canOperate: CashOper,
        share: Share,
        FileID: LFLID,
        ClientId: clientId,
        HashSum_RLClientID_,
        clientRelationType: RLTypeID,
        isEdit: true,
        endDateCheckbox: 1,
      }

      if (moment(EndDate).isValid()) {
        initialValues.endDate = moment(EndDate).format('DD.MM.YYYY')
      } else {
        initialValues.endDate = moment(OpenDay).format('DD.MM.YYYY')
      }
    } else {
      const defNoteType: number = get(options, '[0].value')

      initialValues = {
        active: 1,
        startDate: moment(OpenDay).format('DD.MM.YYYY'),
        endDate: moment(OpenDay).format('DD.MM.YYYY'),
        endDateCheckbox: 1,
        FileID: 0,
      }

      if (!isUndefined(defNoteType)) {
        initialValues.clientRelationType = defNoteType
      }
    }

    return {
      initialValues,
      clientRelationType: valueSelector('state', 'connectionType'),
      FileID: valueSelector(state, 'FileID'),
    }
  },
  {
    openFileDetails,
  },
)
//@ts-ignore
@reduxForm({
  form: addDelegateFormName,
  validate: (values: ClientDelegateAddModalFormValues) => {
    const errors: {
      endDate?: string
    } = {}

    if (LKDate.isValid(values.startDate) && LKDate.isValid(values.endDate) && values.endDateCheckbox === 1) {
      if (LKDate.from(values.startDate) > LKDate.from(values.endDate)) {
        errors.endDate = translateWebMessages('INVALID_DATE')
      }
    }

    return errors
  },
  onSubmit: (
    { comment, active, FileID, startDate, endDate, share, clientRelationType, canOperate, endDateCheckbox },
    dispatch,
    {
      params: { client, isEdit },
      ID,
      hash,
      OpenDay,
      startLoading,
      endLoading,
      params,
    }: {
      params: ClientDelegateAddModalParams
      ID: number
      hash: string
      OpenDay: string
      startLoading: () => void
      endLoading: () => void
    },
  ) => {
    startLoading()
    const Active = parseInt(active, 10) ? 1 : 2
    const CanOperate = parseInt(canOperate, 10) ? 1 : 2
    const formatedOpenDate = new LKDate(moment(OpenDay)).toString()

    let fileHash: string
    if (FileID && FileID !== 0) {
      fileHash = params.linkedfiles.find((lf) => lf.ID === FileID).HashSum_FileID_
    }

    dispatch(
      addEditClientDelegate({
        ID: isEdit ? client.ID : undefined,
        HashSum_DelegateID_: isEdit ? client.HashSum_DelegateID_ : undefined,
        ClientID: ID,
        HashSum_ClientID_: hash,
        Comment: comment,
        Active,
        OperDate: formatedOpenDate,
        StartDate: startDate,
        EndDate: endDateCheckbox === 1 ? endDate : null,
        Share: share,
        RLClientID: isEdit ? client.RLClientID : client.ID,
        HashSum_RLClientID_: isEdit ? client.HashSum_RLClientID_ : client.HashSum_ClientID_,
        FileID,
        HashSum_FileID_: fileHash,
        RLTypeID: clientRelationType,
        CashOper: CanOperate,
      }),
    )
      .then(() => {
        dispatch(LKModalActions.close(addDelegateModalName))
        dispatch(
          DetailsContainerActions.fetchPage({
            type: 'Client',
            ID,
            hash,
            page: 'relations',
          }),
        )
        endLoading()
      })
      .catch((error) => {
        endLoading()
        dispatch(
          LKModalActions.openInfo(translateLKMessage(error.Error.Message || error.Error.Text || error.Error.Code)),
        )
      })
  },
})
class ClientDelegateAddModal extends React.Component<ClientDelegateAddModalProps, ClientDelegateAddModalState> {
  LinkedFiles: { ID: number; Title: string; content: JSX.Element }[]
  constructor(props: ClientDelegateAddModalProps) {
    super(props)

    this.LinkedFiles = this.props.params.linkedfiles.map(({ ID, Title, TypeTitle }) => ({
      ID,
      Title,
      content: (
        <div className="u-flex u-directionRow u-alignCenter">
          <div style={{ width: 50, minWidth: 50, paddingRight: 15, textAlign: 'right' }}>{ID}</div>
          <div style={{ width: 350, minWidth: 300, paddingRight: 15, textAlign: 'left' }}>{TypeTitle}</div>
          <div>{Title.substring(0, 10)}</div>
        </div>
      ),
    }))

    this.LinkedFiles.unshift({
      ID: 0,
      Title: '-- No File Selected -- ',
      content: (
        <div className="u-flex u-directionRow u-alignCenter">
          <div style={{ width: 50, minWidth: 50, paddingRight: 15, textAlign: 'right' }}>--</div>
          <div style={{ width: 350, minWidth: 300, paddingRight: 15, textAlign: 'left' }}>--</div>
          <div>--</div>
        </div>
      ),
    })

    if (this.props.initialValues.isEdit) {
      this.state.endDateDisabled = false
    }
  }

  state = {
    endDateDisabled: false,
  }

  isValidFileExtension = () => {
    const { linkedfiles } = this.props.params

    if (this.props.FileID) {
      const file = linkedfiles.find((lf) => lf.ID === this.props.FileID)
      return file.Ext.toLowerCase() === 'jpg' || file.Ext.toLowerCase() === 'png' || file.Ext.toLowerCase() === 'pdf'
    }
    return false
  }

  viewFile = () => {
    if (this.props.FileID) {
      const file = this.props.params.linkedfiles.find((lf) => lf.ID === this.props.FileID)

      this.props.openFileDetails({ ID: file.ID, hash: file.HashSum_FileID_, type: file.Ext })
    }
  }

  handleStartDateCheckbox = () => {
    this.setState((prevState) => ({
      startDateEnabled: !prevState.startDateEnabled,
    }))
  }

  handleEndDateCheckbox = () => {
    this.setState((prevState) => ({
      endDateDisabled: !prevState.endDateDisabled,
    }))
  }

  render() {
    const {
      modalInstanceName,
      options,
      handleSubmit,
      isLoading,
      params: { client },
    } = this.props

    return (
      <LKModal
        name={modalInstanceName}
        heading={translateDelegates('frm_client_delegate_add_edit')}
        size="medium"
        footer={
          <LKModal.Footer>
            <LKButton alias="ok" onClick={handleSubmit} disabled={isLoading}>
              OK
            </LKButton>

            <LKModal.CancelButton text={translateDelegates('cmd_cancel')} />
          </LKModal.Footer>
        }
      >
        <FormLayout labelFieldProportions="4:10" label={translateDelegates('lbl_firstname')}>
          <Input
            value={`${client.Full_Name} - ${client.CardNumber}`}
            disabled
            style={{
              width: '100%',
            }}
          />
        </FormLayout>

        <FormLayout labelFieldProportions="4:10" label={translateDelegates('lbl_relation')}>
          <DropdownField id="clientRelationType" name="clientRelationType" options={options} />
        </FormLayout>

        <FormLayout labelFieldProportions="4:3" label={translateDelegates('lbl_startdate')}>
          <FormField id="startDate" type="date" name="startDate" />
        </FormLayout>

        <FormLayout labelFieldProportions="4:6" label={translateDelegates('lbl_enddate')}>
          <FormField id="endDate" type="date" name="endDate" disabled={this.state.endDateDisabled} />
          <FormField
            id="endDateDateChecbox"
            name="endDateCheckbox"
            type="checkbox"
            onChange={this.handleEndDateCheckbox}
          />
        </FormLayout>

        <FormLayout labelFieldProportions="4:12" label="">
          <div className="u-flex" style={{ position: 'absolute', top: '5px', left: '34%' }}>
            <FormField id="canOperate" name="canOperate" type="checkbox" style={{ bottom: '3px' }} />
            <label htmlFor="canOperate" style={{ marginLeft: '10px', transform: 'translateY(2px)' }}>
              {translateDelegates('chk_cashoper')}
            </label>
          </div>
        </FormLayout>

        <FormLayout labelFieldProportions="4:10" label={translateDelegates('lbl_share')}>
          <FormField id="share" type="float" name="share" />
        </FormLayout>

        <FormLayout labelFieldProportions="4:10" label={translateDelegates('lbl_comment')} autoHeight>
          <FormField id="comment" type="textarea" name="comment" className="u-fluid u-marginTop-5" />
        </FormLayout>

        <FormLayout labelFieldProportions="4:10" label={translateDelegates('lbl_file_t')}>
          <div style={{ position: 'relative', height: '33px' }}>
            <div className="u-flex" style={{ position: 'fixed', width: '400px' }}>
              <FormField id="FileID" type="select" name="FileID" menuWidth={550} options={this.LinkedFiles} />

              <LKButton
                alias="preview"
                className="u-marginLeft-5"
                onClick={this.viewFile}
                disabled={!this.isValidFileExtension()}
              />
            </div>
          </div>
        </FormLayout>
      </LKModal>
    )
  }
}

export const openDelegateAddModal = (edit, data) => LKModalActions.open({ name: addDelegateModalName, edit, data })

export default ClientDelegateAddModal
